/**
 * Quote Builder staff permissions (mirror of backend deps/auth.py).
 * Owner (admin) and superadmin always have everything. For staff, a key
 * missing on an older record falls back to these defaults.
 */
export const QUOTE_PERMISSION_DEFAULTS = {
  quotes: true,
  customers: true,
  catalog: false,
  stock: true,
  costs: false,
  reports: false,
  service: true,
};

/** Order used on the team page. */
export const QUOTE_PERMISSION_KEYS = ['quotes', 'customers', 'catalog', 'stock', 'service', 'costs', 'reports'];

export function isQuoteOwner(user) {
  return user?.role === 'admin' || user?.role === 'superadmin';
}

export function hasQuotePermission(user, key) {
  if (!user) return false;
  if (isQuoteOwner(user)) return true;
  if (user.role !== 'staff') return false;
  const perms = user.permissions || {};
  if (Object.prototype.hasOwnProperty.call(perms, key)) return !!perms[key];
  return !!QUOTE_PERMISSION_DEFAULTS[key];
}

/** What each page needs. `owner` = business owner only. */
export const QUOTE_PAGE_ACCESS = {
  '/quotes': ['quotes'],
  '/quotes/new': ['quotes'],
  '/quote-customers': ['customers'],
  '/quote-catalog': ['catalog'],
  '/quote-stock': ['stock'],
  '/quote-service': ['service'],
  '/quote-insights': ['reports'],
  '/company-settings': 'owner',
  '/quote-settings': 'owner',
  '/quote-team': 'owner',
  '/quote-upgrade': 'owner',
};

export function canOpenQuotePage(user, path) {
  const rule = QUOTE_PAGE_ACCESS[path];
  if (!rule) return true;
  if (rule === 'owner') return isQuoteOwner(user);
  return rule.some((key) => hasQuotePermission(user, key));
}

/** First page this user may open — used as landing / fallback. */
export function firstAllowedQuotePath(user) {
  const order = ['/quotes', '/quote-stock', '/quote-service', '/quote-customers', '/quote-catalog', '/quote-insights'];
  return order.find((p) => canOpenQuotePage(user, p)) || null;
}
